export default __webpack_public_path__ + "static/media/fintech-2-lt.349e58b9.png";